import { useEffect } from "react";
import PropTypes from "prop-types";

/**
 * @param {Object}
 * @param {number} timeoutSeconds 해당 시간(초 단위) 동안 idle 상태시 타임아웃
 * @param {function} onTimeout 타임아웃시 실행될 함수
 * @param {string[]} [excludedPages = []] 타임아웃 미적용 페이지들 ex) /dashboard/monitoring, /auth/login
 * @returns undefined
 */
const useIdleTimer = ({ timeoutSeconds, onTimeout, excludePages = [] }) => {
  useEffect(() => {
    if (excludePages.includes(window.location.pathname)) {
      return;
    }

    let idleTimer = null;

    const startIdleTimer = () => {
      idleTimer = window.setTimeout(() => {
        onTimeout();
      }, timeoutSeconds * 1000);
    };

    const clearIdleTimer = () => {
      window.clearTimeout(idleTimer);
    };

    const handleUserEvent = () => {
      clearIdleTimer();
      startIdleTimer();
    };

    window.addEventListener("mousemove", handleUserEvent);
    window.addEventListener("mousedown", handleUserEvent);
    window.addEventListener("wheel", handleUserEvent);
    window.addEventListener("keydown", handleUserEvent);

    startIdleTimer();

    return () => {
      window.removeEventListener("mousemove", handleUserEvent);
      window.removeEventListener("mousedown", handleUserEvent);
      window.removeEventListener("wheel", handleUserEvent);
      window.removeEventListener("keydown", handleUserEvent);

      clearIdleTimer();
    };
  }, [timeoutSeconds, onTimeout, excludePages]);

  return;
};

useIdleTimer.propTypes = {
  timeoutSeconds: PropTypes.number.isRequired,
  onTimeout: PropTypes.func.isRequired,
  excludePages: PropTypes.arrayOf(PropTypes.string),
};

export default useIdleTimer;
